import { render } from "./CardFormFirstObjects.vue?vue&type=template&id=d6bd820a&ts=true"
import script from "./CardFormFirstObjects.vue?vue&type=script&lang=ts"
export * from "./CardFormFirstObjects.vue?vue&type=script&lang=ts"

import "./CardFormFirstObjects.vue?vue&type=style&index=0&id=d6bd820a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__